<template>
  <div class="receiverList">
    <div class="query">
      <div style="display: flex; align-items: center; justify-self: flex-start">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item label="" style="margin-bottom: 0px">
            <el-input
              v-model="company_name"
              size="small"
              placeholder="用户名称/账号"
            ></el-input>
          </el-form-item>
          <el-form-item class="mgl10" style="margin-bottom: 0px">
            <el-button type="primary" @click="toSearch" size="small">
              查 询
            </el-button>
            <el-button type="primary" @click="resetList" size="small">
              重 置
            </el-button>
          </el-form-item>
        </el-form>
        
      </div>
      <!-- <div class="operate-btn"> -->
          <el-button
            type="primary"
            class="btn"
            size="small"
            @click="operateBtn('add_btn')"
            >新增角色
            <i class="el-icon-circle-plus-outline"></i>
          </el-button>
        <!-- </div> -->
    </div>
    <div
      style="display: flex; align-items: center; justify-content: space-between"
    ></div>
    <div class="table">
      <el-table
        :data="tableData"
        ref="tableData"
        stripe
        @selection-change="handleSelectionChange"
        :height="tableHeight"
      >
        <!-- <el-table-column align="center" type="selection" width="55">
        </el-table-column> -->
        <el-table-column
          v-for="column in columns"
          :key="column"
          :prop="column"
          :label="$t(`label.open.${column}`)"
          align="center"
          show-overflow-tooltip
          :min-width="column == 'operate' ? '180px' : ''"
        >
          <template slot-scope="{ row }">
            <template v-if="column == 'operate'">
              <el-button
                type="warning"
                size="small"
                @click="operateBtn('edit_btn', row)"
                >信息编辑</el-button
              >
              <el-button
                v-if="row.status === 0"
                type="danger"
                size="small"
                @click="operateBtn('freeze', row)"
                >冻结</el-button
              >
              <el-button
                v-else
                type="primary"
                size="small"
                @click="operateBtn('unfreeze', row)"
                >解冻</el-button
              >
            </template>
            <template v-else>
              {{ row[column] }}
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        background
        layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        :total="total"
        popper-class="mySelectType"
        :current-page="page"
        @size-change="sizeChange"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
    <userEdit :show.sync="showRoleEdit" :rowInfo.sync="rowInfo" :orgData="orgdata" @refush="getRoleList">
    </userEdit>
  </div>
</template>
  
  <script>
import {
  queryUserInfo,
  freezeAccount,
  unfreezeAccount,
  queryOrgInfo,
} from "@/api/index";
import userEdit from "./components/userEdit.vue";
// import ViewDevice from "./component/viewDevice.vue";
// import viewDeviceDetail from "./component/viewDetail.vue";
// import AddThird from "./component/addThird.vue";
export default {
  data() {
    return {
      orgdata: [],
      showRoleEdit: false,
      rowInfo: {},
      columns: ["index", "account", "user", "org", "role", "time", "operate"],
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 10,
      company_name: "",
      userinfo: "",
      sn: "",
      ownership: "",
      fileList: [],
      // showAddThirdDevice: false,
      showAddThirdManu: false,
      showViewDevice: false,
      showAddThirdDevice: false,
      showDeviceDetail: false,
      showDis: false,
      choose: [],
      selectValue: [],
      tableHeight: 450,
    };
  },
  components: {
    userEdit,
  },
  mounted() {
    this.$nextTick(() => {
      // window.innerHeight 浏览器窗口的可见高度，下面的 220 是除了table最大高度的剩余空间。
      let height =
        window.innerHeight - this.$refs.tableData.$el.offsetHeight + 225;
      this.tableHeight = height;
      // this.getRoleList();
      // this.getOrgList();
    });
  },
  activated(){
    this.$nextTick(() => {
      this.getRoleList();
      this.getOrgList();
    });
  },
  methods: {
    toSearch(){
      this.page = 1
      this.getRoleList()
    },
    // 获取机构列表
    getOrgList() {
      // 获取当前所有机构列表
      queryOrgInfo().then((res) => {
        this.orgdata = this.generateOptions(res.data);
        // this.currentOrg = this.orgdata[0].id;

        // this.$refs.tree.handleCheckChange(this.orgdata[0]);
      });
    },
    // 递归处理接口数据
    generateOptions(params) {
      let result = [];
      for (const param of params) {
        if (param.pid == 0) {
          // 判断是否为顶层节点
          let parent = {
            id: param.org_id,
            label: param.name,
            pname: param.pname,
            describe: param.describe,
            created_at: param.created_at,
          };
          parent.children = this.getchilds(param.org_id, params); // 获取子节点
          result.push(parent);
        }
      }
      return result;
    },
    getchilds(value, array) {
      const childs = [];
      for (const arr of array) {
        // 循环获取子节点
        if (arr.pid === value) {
          childs.push({
            id: arr.org_id,
            label: arr.name,
            pname: arr.pname,
            describe: arr.describe,
            created_at: arr.created_at,
          });
        }
      }
      for (const child of childs) {
        // console.log(childs, "sssss")
        // 获取子节点的子节点
        const childscopy = this.getchilds(child.id, array); // 递归获取子节点
        if (childscopy.length > 0) {
          child.children = childscopy;
        }
      }
      return childs;
    },
    getRoleList() {
      let param = {
        keyword: this.company_name,
        page_size: this.pageSize,
        page_num: this.page,
      };
      queryUserInfo(param).then((res) => {
        if (res.code == 200) {
          // console.log(res, "ressss"); 
          this.total = res.data.total
          this.tableData = res.data.infos.map((item, index) => {
            return {
              index: (this.page - 1) * this.pageSize + index + 1,
              id: item.user_id,
              account: item.account,
              user: item.name,
              org:this.filterArr(item.orgInfo, "name"), // 机构名
              orgId: this.filterArr(item.orgInfo, "id"), // 机构id
              // org:item.orgInfo[0] ? item.orgInfo[0].org_name : "-", // 机构名
              // orgId: item.orgInfo[0] ? item.orgInfo[0].org_id : "-", // 机构id
              role: item.role_name,
              roleId: item.role_id,
              time: item.created_at || "-",
              status: item.state, // 0 正常 1 冻结
              orgInfo: item.orgInfo 
            };
          });
          // console.log(this.tableData, "tttt")
        }
      });
    },
    filterArr(param, key){
      let arr = []
      param.forEach(item => {
        if(key == 'name'){
          item.org_name ? arr.push(item.org_name) : arr = []
        } else {
          item.org_id ? arr.push(item.org_id) : arr = []
        }
      })
      return arr.join(",")
    },
    toggleShowRoleEdit() {
      this.showRoleEdit = !this.showRoleEdit;
    },
    operateBtn(e, row = {}) {
      this.rowInfo = row;
      if (e == "add_btn") {
        // 新增
        // this.rowInfo = null
        this.showRoleEdit = true;
      } else if (e == "edit_btn") {
        // 编辑
        // this.rowInfo = row
        this.showRoleEdit = true;
      } else if (e == "unfreeze") {
        // 解冻
        this.$confirm("确认解冻该账号？", "解冻账号", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            unfreezeAccount({ user_id: row.id }).then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "解冻成功!",
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
              this.getRoleList();
            });
          })
          .catch(() => { return });
      } else if (e == "freeze") {
        // 冻结
        this.$confirm("冻结账号后账号将无法使用，确认冻结？", "冻结账号", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            freezeAccount({ user_id: row.id }).then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "冻结成功!",
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
              this.getRoleList();
            });
          })
          .catch(() => {});
      }
    },
    add_role() {
      this.roleEditState = 1; // 新增
      this.toggleShowRoleEdit();
    },
    edit_role() {
      this.roleEditState = 2; // 编辑

      this.toggleShowRoleEdit();
    },
    // 选择设备
    handleSelectionChange(e) {
      this.choose = e.map((_f) => {
        return _f.id;
      });
    },
    toggleShowAddThirdDevice() {
      this.showAddThirdDevice = !this.showAddThirdDevice;
    },
    closeDis() {
      this.showDis = false;
    },
    // 分页
    sizeChange(e) {
      this.page = 1
      this.pageSize = e;
      this.getRoleList()
    },
    // 页数
    currentChange(e) {
      this.page = e;
      this.getRoleList()
    },
    resetList() {
      this.page = 1;
      this.company_name = "";
      // this.userinfo = "";
      // this.total = 0;
      this.getRoleList();
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.receiverList {
  padding: 20px;

  .query {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .input-width {
    max-width: 400px;
  }

  .operate-btn {
    display: flex;
    align-items: center;
  }

  .btn {
    min-width: 80px;
    height: 32px;
  }

  .table {
    border-radius: 2px 2px 0px 0px;
    overflow: hidden;
    margin-top: 10px;
    &::v-deep th.el-table__cell {
      background-color: $table_header;
      color: #fff;
    }

    &::v-deep td.el-table__cell {
      background: transparent !important;
    }

    &::v-deep .el-table__row--striped {
      background-color: #d2e9ce;
    }
  }

  .pagination {
    // display: flex;
    // align-items: center;
    // justify-content: flex-end;
    // margin-top: 12px;
    position: fixed;
    bottom: 0px;
    right: 20px;
    // width: 100%;
    display: flex;
    justify-content: flex-end;
    background-color: #ffffff;
    z-index: 999;
    padding-bottom: 10px;
  }

  ::v-deep {
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #3b9167;
      color: #fff;
    }

    .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
      background-color: #ffffff;
      border: 1px solid #e8e8e8;
    }

    .el-pagination.is-background .el-pager li:hover {
      color: #3b9167;
    }

    .el-pagination__sizes .el-input .el-input__inner:hover {
      border-color: #3b9167;
    }

    .el-select .el-input__inner:focus {
      border-color: #3b9167;
    }

    .el-select-dropdown__item.selected {
      color: #3b9167 !important;
    }

    .el-button--success.is-disabled {
      background-color: #c0c4cc;
      border-color: #c0c4cc;
    }

    // .el-pagination.is-background .el-pager li:not(.disabled):hover {
    // 	color: #3b9167;
    // }
  }
}
.mgl10 {
  margin-left: 10px;
}
</style>
  <style lang="scss">
.mySelectType {
  .el-select-dropdown__item.selected {
    color: #3b9167 !important;
  }
}
</style>
  